"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineSequenceFrame = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const relativeFrameStyle = {
    fontSize: 11,
    fontFamily: 'Arial, Helvetica, sans-serif',
    color: 'white',
    opacity: 0.5,
};
const TimelineSequenceFrame = ({ roundedFrame, premounted }) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: relativeFrameStyle, children: premounted ? '0 (Premounted)' : roundedFrame }));
};
exports.TimelineSequenceFrame = TimelineSequenceFrame;
